import { createStyles, Theme } from '@material-ui/core';
import type { TabsProps } from './Tabs';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    width: '100%',
  },
  overflow: {
    overflow: 'visible!important',
  },
  tabs: {
    minHeight: 'auto',
    borderBottom: `2px solid ${colors.layout.divider300}`,
    paddingLeft: ({ horizontPadding = 0 }: TabsProps) => spacing(1) * horizontPadding,
    paddingRight: ({ horizontPadding = 0 }: TabsProps) => spacing(1) * horizontPadding,

    '& .Mui-selected': {
      color: colors.navigation.tab.selected.name,
      background: colors.navigation.tab.selected.fill,
      borderBottom: `2px solid ${colors.text.primary}`,
    },
  },
  tabsWithBorderRadius: {
    borderEndEndRadius: spacing(1),
    borderEndStartRadius: spacing(1),
  },
  tabRoot: {
    position: 'relative',
    color: colors.navigation.tab.enabled.name,
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    minHeight: 'auto',
    borderBottom: '2px solid transparent',
    marginBottom: '-2px',
    borderTopRightRadius: spacing(1),
    borderTopLeftRadius: spacing(1),
    '&:hover': {
      opacity: 1,
      color: colors.navigation.tab.hovered.name,
      background: colors.navigation.tab.hovered.fill,
      borderBottom: `2px solid ${colors.text.primary}`,
    },
  },
  indicator: {
    display: 'none',
  },
  largeSize: {
    padding: `${spacing(1) + 2}px 0`,
  },
  mediumSize: {
    padding: `${spacing(2)}px ${spacing(3)}px`,
  },
  smallSize: {
    padding: '2px 0',
  },
  content: {
    paddingLeft: ({ horizontPadding = 0 }: TabsProps) => spacing(1) * horizontPadding,
    paddingRight: ({ horizontPadding = 0 }: TabsProps) => spacing(1) * horizontPadding,
  },
});

export default styles;
